import React, { useContext } from 'react';
import { FlowContext } from '../../../core/flow-engine';
import { RewardsContext } from '../../../context/RewardsContext/RewardsContext';
import PhoneNumber from '../../../components/PhoneNumber/PhoneNumber';
import {
  CartContextProvider,
  CartContext
} from '../../../context/CartContext/CartContext';
import { getRewardsAvailable } from '../../../flows/shared/summit.utils';
import { formatFundLaterFunds } from '../../../flows/shared/utils';
import styles from './style.css';
import { MFBeaconButton } from '../../../components/Beacon/BeaconComponents';
import Heading from '../../../components/Typography/Heading/Heading';
import SubHeading from '../../../components/Typography/SubHeading/SubHeading';
import FundLaterFundContents from '../../../components/AllocationTable/v2/FundLaterFundContents';
import { mapFundLaterFundData } from '../../../hooks/useCartDetailsState';

export const FundLaterReviewContent = () => {
  const { next, appState } = useContext(FlowContext);

  const { currentTier = 0 } = useContext(RewardsContext) || {};

  const {
    store: { accountType, app, amount, inReviewMode, loadedData = {} }
  } = appState;
  const { trust, trustee } = app;

  const { shoppingFunds } = loadedData;

  const rewardsAvailable = getRewardsAvailable(
    accountType,
    trust,
    trustee,
    currentTier
  );

  const cartState = useContext(CartContext);
  const { selectedFunds = [], data = {} } = cartState;
  const { mutualFunds = [] } = data;
  const selectedFundsWithData = mapFundLaterFundData(
    selectedFunds,
    mutualFunds
  );

  return (
    <div>
      <Heading text="Review your selected investments" />
      <SubHeading text="You can buy shares of the investments you selected after opening your account." />
      <div className="my-portfolio">
        <FundLaterFundContents
          fundsWithCategories={selectedFundsWithData}
          rewardsAvailable={rewardsAvailable}
          amount={amount}
          handleAddMoreFundsClick={next(
            selectedFundsWithData,
            'reselect-funds'
          )}
          displayAddMore
        />
      </div>

      <div className="button-container">
        <MFBeaconButton
          disabled={!selectedFundsWithData.length}
          id="investmentReviewContinue"
          data-name="investmentReviewContinue"
          variant="primary"
          size="normal"
          className="beacon-button-margin-override"
          onClick={next(selectedFundsWithData)}
          label={inReviewMode ? 'Continue to Confirmation' : 'Continue'}
        />
        {shoppingFunds && (
          <MFBeaconButton
            id="investmentReviewReselect"
            data-name="investmentReviewReselect"
            variant="secondary"
            size="normal"
            className="beacon-button-margin-override"
            onClick={next(selectedFundsWithData, 'reselect-funds')}
            label="Re-select investments"
          />
        )}
        <MFBeaconButton
          id="investmentReviewBack"
          variant="secondary"
          size="normal"
          className="beacon-button-margin-override"
          onClick={next(selectedFundsWithData, 'updateAndBack')}
          label="Back"
        />
      </div>

      <PhoneNumber />
      <style jsx>{styles}</style>
    </div>
  );
};

const FundLaterInvestmentReviewScreen = ({ appState }) => {
  const {
    store: { chosenInvestments, amount, loadedData = {} }
  } = appState;

  const funds =
    !chosenInvestments?.length && loadedData.shoppingFunds
      ? loadedData.shoppingFunds
      : chosenInvestments;

  const formattedSelectedFunds = formatFundLaterFunds(funds);

  return (
    <CartContextProvider
      initialTotalAmount={amount}
      initialPercentMode
      initialFunds={formattedSelectedFunds}>
      <FundLaterReviewContent />
    </CartContextProvider>
  );
};

export default FundLaterInvestmentReviewScreen;
